/**
 * Created by akrio on 2018/4/27.
 */
export const pricingPackageList = [
  {
    type: "FREE",
    price: "$0",
    background: " #da16ae",
    des: `+ Unlimited Instagram accounts
+ 10 schedules per month per account`,
    active: true,
  },
  {
    type: "STARTER",
    price: "$10",
    background: " #dc0c94",
    des: `Everything in Free Plan:
+ 1 Instagram accounts with unlimited schedules`,
  },
  {
    type: "PRO",
    price: "$20",
    background: " #e50779",
    des: `Everything in Free Plan plus:
+ 5 Instagram accounts with unlimited schedules
+ 1 Manager`,
  },
  {
    type: "TEAM",
    price: "$50",
    background: " #ed035b",
    des: `Everything in Free Plan plus:
+ 20 Instagram accounts with unlimited schedules
+ 4 Manager`,
  },
  {
    type: "BUSINESS",
    price: "$100",
    background: " #e50140",
    des: `Everything in Free Plan plus:
+ 20 Instagram accounts with unlimited schedules
+ 4 Manager`,
  },
];
/**
 * linked instagram 方式
 * @type {*[]}
 */
export const linkedInstagramTypes = [
  { type: 1, text: "" },
  { type: 2, text: "Unlimited" },
  { type: 3, text: "A team member of" },
];
